<template>
  <div>
    <van-nav-bar  title="订单中心" left-arrow @click-left="onClickLeft" />
    <div style="background-color: #f7f7f7">
      <van-tabs sticky v-model="active" @click="onClick">
        <van-tab title="全部">
            <div class="prod-item" v-for="(item, index) in list" :key="index">
              <div  @click="toOrderDetailPage(item.orderNumber)">
                <div class="order-num">
              <span>订单编号：{{ item.orderNumber }}</span>
              <div class="order-state">
                <span>{{['','待支付','待发货','待收货','已完成','已完成','已取消','拼团中'][item.status]}}</span>
              </div>
            </div>
            <div v-if="item.orderItemDtos.length == 1">
              <div
                class="item-cont"
                v-for="(prod, i) in item.orderItemDtos"
                :key="i"
              >
                <div class="prod-pic">
                  <img
                    :src="prod.pic"
                    alt=""
                    style="width: 100%; height: 100%"
                  />
                </div>
                <div class="prod-info">
                  <div class="prodname">{{ prod.prodName }}</div>
                  <div class="prod-info-cont">
                    <div class="prod-skuname">{{ prod.skuName }}</div>
                  </div>
                  <div class="price-nums">
                    <span class="prodprice">
                      <span v-if="activityId === 9 || activityId === 13" class="symbol">
                        <img :src="'https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png'" style="width: 12px; height: 12px; vertical-align: middle;">
                      </span>
                      <span v-else class="symbol">￥</span>
                      <span class="big-num">{{ prod.price.toFixed(2) }}</span>
                    </span>
                    <span class="prodcount">x{{ prod.prodCount }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="prod-item">
                <div class="item-cont" >
                  <div
                    style="
                      overflow: hidden;
                      white-space: nowrap;
                      width: 100%;
                      overflow-x: auto;
                    "
                  >
                    <div class="prod-pic"  v-for="(prod, i) in item.orderItemDtos" :key="i">
                      <img
                        :src="prod.pic"
                        alt=""
                        style="width: 100%; height: 100%"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
              </div>

            <div class="total-num">
              <span class="prodcount">共{{ item.totalCounts }}件商品</span>
              <div class="prodprice">
                合计
                <span v-if="activityId === 9 || activityId === 13" class="symbol">
                  <img :src="'https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png'" style="width: 12px; height: 12px; vertical-align: middle;">
                </span>
                <span v-else class="symbol">￥</span>
                <span class="big-num">{{ item.actualTotal.toFixed(2) }}</span>
              </div>
            </div>
            <div class="prod-foot">
              <div class="btn" v-if="item.status==3">
                <span class="button">确认收货</span>
              </div>
              <div class="btn" v-if="item.status==3 || item.status==5 || item.deliveryStatus==1" @click="toDeliveryPage(item.orderNumber)">
                <span class="button" >查看物流</span>
              </div>
            </div>
          </div>
        </van-tab>
        <van-tab title="待支付">
          <div class="prod-item" v-for="(item, index) in list" :key="index">
            <div  @click="toOrderDetailPage(item.orderNumber)">
              <div class="order-num">
              <span>订单编号：{{ item.orderNumber }}</span>
              <div class="order-state">
                <span>{{['','待支付','待发货','待收货','已完成','已完成','已取消','拼团中'][item.status]}}</span>
              </div>
            </div>
            <div v-if="item.orderItemDtos.length == 1">
              <div
                class="item-cont"
                v-for="(prod, i) in item.orderItemDtos"
                :key="i"
              >
                <div class="prod-pic">
                  <img
                    :src="prod.pic"
                    alt=""
                    style="width: 100%; height: 100%"
                  />
                </div>
                <div class="prod-info">
                  <div class="prodname">{{ prod.prodName }}</div>
                  <div class="prod-info-cont">
                    <div class="prod-skuname">{{ prod.skuName }}</div>
                  </div>
                  <div class="price-nums">
                    <span class="prodprice">
                      <span v-if="activityId === 9 || activityId === 13" class="symbol">
                        <img :src="'https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png'" style="width: 12px; height: 12px; vertical-align: middle;">
                      </span>
                      <span v-else class="symbol">￥</span>
                      <span class="big-num">{{ prod.price.toFixed(2) }}</span>
                    </span>
                    <span class="prodcount">x{{ prod.prodCount }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="prod-item">
                <div class="item-cont" >
                  <div
                    style="
                      overflow: hidden;
                      white-space: nowrap;
                      width: 100%;
                      overflow-x: auto;
                    "
                  >
                    <div class="prod-pic"  v-for="(prod, i) in item.orderItemDtos" :key="i">
                      <img
                        :src="prod.pic"
                        alt=""
                        style="width: 100%; height: 100%"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>

            <div class="total-num">
              <span class="prodcount">共{{ item.totalCounts }}件商品</span>
              <div class="prodprice">
                合计
                <span v-if="activityId === 9 || activityId === 13" class="symbol">
                  <img :src="'https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png'" style="width: 12px; height: 12px; vertical-align: middle;">
                </span>
                <span v-else class="symbol">￥</span>
                <span class="big-num">{{ item.actualTotal.toFixed(2) }}</span>
              </div>
            </div>
            <div class="prod-foot">
              <div class="btn" v-if="item.status==1" @click="showPopup(item.orderNumber)">
                <span class="button" >付款</span>
              </div>
              <div class="btn" v-if="item.status==1 ||item.status==2" @click="uPaddress(item.orderNumber,item.addrOrderId,item.status,item.payTime)">
                <span class="button" >修改地址</span>
              </div>
              <div class="btn" v-if="item.status==3">
                <span class="button">确认收货</span>
              </div>
              <div class="btn" v-if="item.status==3 || item.status==5 || item.deliveryStatus==1" @click="toDeliveryPage(item.orderNumber)">
                <span class="button" >查看物流</span>
              </div>
            </div>
          </div>
          <div class="empty" v-if="!list.length">
            <div class="empty-icon">
              <img src="https://img.zhujiaxian.com/2024/09/a929568e7a4949c8b008313bf609a8eb.png" />
            </div>
            <div class="empty-text">这里还没有相关订单~</div>
          </div>
        </van-tab>
        <van-tab title="待发货">
          <div class="prod-item" v-for="(item, index) in list" :key="index">
            <div @click="toOrderDetailPage(item.orderNumber)">
              <div class="order-num">
              <span>订单编号：{{ item.orderNumber }}</span>
              <div class="order-state">
                <span>{{['','待支付','待发货','待收货','已完成','已完成','已取消','拼团中'][item.status]}}</span>
              </div>
            </div>
            <div v-if="item.orderItemDtos.length == 1">
              <div
                class="item-cont"
                v-for="(prod, i) in item.orderItemDtos"
                :key="i"
              >
                <div class="prod-pic">
                  <img
                    :src="prod.pic"
                    alt=""
                    style="width: 100%; height: 100%"
                  />
                </div>
                <div class="prod-info">
                  <div class="prodname">{{ prod.prodName }}</div>
                  <div class="prod-info-cont">
                    <div class="prod-skuname">{{ prod.skuName }}</div>
                  </div>
                  <div class="price-nums">
                    <span class="prodprice">
                      <span v-if="activityId === 9 || activityId === 13" class="symbol">
                        <img :src="'https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png'" style="width: 12px; height: 12px; vertical-align: middle;">
                      </span>
                      <span v-else class="symbol">￥</span>
                      <span class="big-num">{{ prod.price.toFixed(2) }}</span>
                    </span>
                    <span class="prodcount">x{{ prod.prodCount }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="prod-item">
                <div class="item-cont" >
                  <div
                    style="
                      overflow: hidden;
                      white-space: nowrap;
                      width: 100%;
                      overflow-x: auto;
                    "
                  >
                    <div class="prod-pic"  v-for="(prod, i) in item.orderItemDtos" :key="i">
                      <img
                        :src="prod.pic"
                        alt=""
                        style="width: 100%; height: 100%"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>

            <div class="total-num">
              <span class="prodcount">共{{ item.totalCounts }}件商品</span>
              <div class="prodprice">
                合计
                <span v-if="activityId === 9 || activityId === 13" class="symbol">
                  <img :src="'https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png'" style="width: 12px; height: 12px; vertical-align: middle;">
                </span>
                <span v-else class="symbol">￥</span>
                <span class="big-num">{{ item.actualTotal.toFixed(2) }}</span>
              </div>
            </div>
            <div class="prod-foot">
              <div class="btn" @click="uPaddress(item.orderNumber,item.addrOrderId,item.status,item.payTime)">
                <span class="button" >修改地址</span>
              </div>
              <div class="btn" v-if="item.status==3">
                <span class="button">确认收货</span>
              </div>
              <div class="btn" v-if="item.status==3 || item.status==5 || item.deliveryStatus==1" @click="toDeliveryPage(item.orderNumber)">
                <span class="button" >查看物流</span>
              </div>
            </div>
          </div>
          <div class="empty" v-if="!list.length">
            <div class="empty-icon">
              <img src="https://img.zhujiaxian.com/2024/09/a929568e7a4949c8b008313bf609a8eb.png" />
            </div>
            <div class="empty-text">这里还没有相关订单~</div>
          </div>
        </van-tab>
        <van-tab title="待收货">
          <div class="prod-item" v-for="(item, index) in list" :key="index">
            <div   @click="toOrderDetailPage(item.orderNumber)">
              <div class="order-num">
              <span>订单编号：{{ item.orderNumber }}</span>
              <div class="order-state">
                <span>{{['','待支付','待发货','待收货','已完成','已完成','已取消','拼团中'][item.status]}}</span>
              </div>
            </div>
            <div v-if="item.orderItemDtos.length == 1">
              <div
                class="item-cont"
                v-for="(prod, i) in item.orderItemDtos"
                :key="i"
              >
                <div class="prod-pic">
                  <img
                    :src="prod.pic"
                    alt=""
                    style="width: 100%; height: 100%"
                  />
                </div>
                <div class="prod-info">
                  <div class="prodname">{{ prod.prodName }}</div>
                  <div class="prod-info-cont">
                    <div class="prod-skuname">{{ prod.skuName }}</div>
                  </div>
                  <div class="price-nums">
                    <span class="prodprice">
                      <span v-if="activityId === 9 || activityId === 13" class="symbol">
                        <img :src="'https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png'" style="width: 12px; height: 12px; vertical-align: middle;">
                      </span>
                      <span v-else class="symbol">￥</span>
                      <span class="big-num">{{ prod.price.toFixed(2) }}</span>
                    </span>
                    <span class="prodcount">x{{ prod.prodCount }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="prod-item">
                <div class="item-cont" >
                  <div
                    style="
                      overflow: hidden;
                      white-space: nowrap;
                      width: 100%;
                      overflow-x: auto;
                    "
                  >
                    <div class="prod-pic"  v-for="(prod, i) in item.orderItemDtos" :key="i" @click="toOrderDetailPage(prod.orderNumber)">
                      <img
                        :src="prod.pic"
                        alt=""
                        style="width: 100%; height: 100%"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>

            <div class="total-num">
              <span class="prodcount">共{{ item.totalCounts }}件商品</span>
              <div class="prodprice">
                合计
                <span v-if="activityId === 9 || activityId === 13" class="symbol">
                  <img :src="'https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png'" style="width: 12px; height: 12px; vertical-align: middle;">
                </span>
                <span v-else class="symbol">￥</span>
                <span class="big-num">{{ item.actualTotal.toFixed(2) }}</span>
              </div>
            </div>
            <div class="prod-foot">
              <div class="btn" v-if="item.status==3">
                <span class="button">确认收货</span>
              </div>
              <div class="btn" v-if="item.status==3 || item.status==5 || item.deliveryStatus==1" @click="toDeliveryPage(item.orderNumber)">
                <span class="button" >查看物流</span>
              </div>
            </div>
          </div>
          <div class="empty" v-if="!list.length">
            <div class="empty-icon">
              <img src="https://img.zhujiaxian.com/2024/09/a929568e7a4949c8b008313bf609a8eb.png" />
            </div>
            <div class="empty-text">这里还没有相关订单~</div>
          </div>
        </van-tab>
        <van-tab title="已完成">
          <div class="prod-item" v-for="(item, index) in list" :key="index">
            <div  @click="toOrderDetailPage(item.orderNumber)">
              <div class="order-num">
              <span>订单编号：{{ item.orderNumber }}</span>
              <div class="order-state">
                <span>{{['','待支付','待发货','待收货','已完成','已完成','已取消','拼团中'][item.status]}}</span>
              </div>
            </div>
            <div v-if="item.orderItemDtos.length == 1">
              <div
                class="item-cont"
                v-for="(prod, i) in item.orderItemDtos"
                :key="i"
               
              >
                <div class="prod-pic">
                  <img
                    :src="prod.pic"
                    alt=""
                    style="width: 100%; height: 100%"
                  />
                </div>
                <div class="prod-info">
                  <div class="prodname">{{ prod.prodName }}</div>
                  <div class="prod-info-cont">
                    <div class="prod-skuname">{{ prod.skuName }}</div>
                  </div>
                  <div class="price-nums">
                    <span class="prodprice">
                      <span class="symbol">￥</span>
                      <span class="big-num">{{ prod.price.toFixed(2) }}</span>
                    </span>
                    <span class="prodcount">x{{ prod.prodCount }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="prod-item">
                <div class="item-cont" >
                  <div
                    style="
                      overflow: hidden;
                      white-space: nowrap;
                      width: 100%;
                      overflow-x: auto;
                    "
                  >
                    <div class="prod-pic"  v-for="(prod, i) in item.orderItemDtos" :key="i">
                      <img
                        :src="prod.pic"
                        alt=""
                        style="width: 100%; height: 100%"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>

            <div class="total-num">
              <span class="prodcount">共{{ item.totalCounts }}件商品</span>
              <div class="prodprice">
                合计
                <span class="symbol">￥</span>
                <span class="big-num">{{ item.actualTotal.toFixed(2) }}</span>
              </div>
            </div>
            <div class="prod-foot">
              <div class="btn" v-if="item.status==3">
                <span class="button">确认收货</span>
              </div>
              <div class="btn" v-if="item.status==3 || item.status==5 || item.deliveryStatus==1" @click="toDeliveryPage(item.orderNumber)">
                <span class="button">查看物流</span>
              </div>
            </div>
          </div>
          <div class="empty" v-if="!list.length">
            <div class="empty-icon">
              <img src="https://img.zhujiaxian.com/2024/09/a929568e7a4949c8b008313bf609a8eb.png" />
            </div>
            <div class="empty-text">这里还没有相关订单~</div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <van-popup v-model="show" closeable round :style="{ height: '30%',width:'80%' }">
      <div class="radios" style="margin: 25px;">
        <div>
          <p style="font-size: 17px;">选择支付方式</p>
        </div>
        <div style="font-size:14px;margin:20px 0px;">
          <van-radio-group v-model="radio" direction="horizontal">
            <van-radio  @click="radios('11')" name="11" checked-color="#ee0a24" icon-size="18px">余额账户</van-radio>
            <van-radio  @click="radios('2')" name="2" checked-color="#ee0a24" icon-size="18px">微信支付</van-radio>
          </van-radio-group>
        </div>
        
        <div>
          <van-button type="danger" round size="small" @click="confirmPay">确定</van-button>
        </div>
      </div>
      
    </van-popup>
  </div>
</template>
<script src="http://res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
<script>
import { Dialog } from "vant";
import { GetmyOrder,GetUserInfo,getSubmit,getPay,getOpenids,getpayBalance } from "@/https/http";
const isWechat = () => {
		return String(navigator.userAgent.toLowerCase().match(/MicroMessenger/i)) === "micromessenger";
	}
export default {
  data() {
    return {
      radio: '11',
      active: 1,
      size: 10,
      current: 1,
      list: [],
      show: false,
      pages: "",
      payType: "11",
      orders: [],
      list:[],
      userInfo: {},
      ordernum:null,
      // activityId: 9, // 默认活动ID为9
    };
  },
  created() {
    this.active = parseInt(this.$route.query.id);
    this.Myorder();
    this.userinfo();
    this.getWechatCode()
  },
  methods: {
        //获取当前用户信息
        userinfo() {
        GetUserInfo().then((res) => {
          console.log(res);
          this.userInfo = res.data;
        });
      },
    radios(e){
      console.log(e);
      this.radio = e
      console.log(   this.radio,'   this.radio');
    },
    showPopup(e) {
      this.show = true;
      this.ordernum = e;
    },
    confirmPay(e){
      if(this.radio == '2'){
        this.payType = 5;
        this.calWeixinPay(this.ordernum)
      }else{
        var balance = this.userInfo.corporateAccounts;
        var list = this.list;
        var item = {};
        for (var i = 0; i < list.length; i++) {
          console.log(list[i].orderNumber == this.ordernum);
          if (list[i].orderNumber == this.ordernum) {
            item = list[i];
            break;
          }
        }
        console.log('item.actualTotal:' + item.actualTotal);
        if (item.actualTotal > balance) {
          this.payType = 13;
          this.onPayAgain();
        } else {
          console.log('balance:' + balance);
          this.onPayBalance();
          this.payType = 11;
        }
      }
    },
    //余额支付
    onPayBalance(){
      let orderShopParam = {
            payType: 11,
            remarks: "",
            attribute: 1,
            shopId: 1,
            orderNumbers:this.ordernum,
          };
      // getSubmit(orderShopParam).then((res) => {
      //   console.log(res);
      //     this.$router.push({ path: "/pay-result",query:{orderNumbers:this.orderNumbers,sts:1,payType:9,orderType:this.orderType}});
      // });
      getpayBalance(orderShopParam).then(res=>{
        console.log(res.data);
        this.$router.push({ path: "/pay-result",query:{orderNumbers:this.orderNumbers,sts:1,payType:11,orderType:this.orderType}});
      })  
    },
    //组合支付
    onPayAgain(){
      let orderShopParam = {
        orderShopParam: [
          {
            payType: 13,
            remarks: "",
            attribute: 1,
            shopId: 1,
            h5Order:7,
          },
        ],
      };
      // getSubmit(orderShopParam).then((res) => {
      //   console.log(res);
        
      // });
      this.calWeixinPay(this.ordernum,);
    },
    //准备微信支付
    calWeixinPay(o){
      let openid = window.localStorage.getItem('openID');
      // let data = {
      //   orderNumbers:o,
      //   payType:this.payType,
      //   openID:openid
      //   };
        let data = {
          orderNumbers:o,
          payType:this.payType,
          orderType:0,
          openID:openid
        };
      getpayBalance(data).then(res=>{
        console.log(res.data);
        this.onBridgeReady(res.data)
      })   
      // getPay(data).then(res=>{
      //   console.log(res.data);
      //   this.onBridgeReady(res.data)
      // })
    },
    onBridgeReady(params) {
					console.log(this.params,'params');
					console.log(params,'params');
					var appids = ''
					appids = JSON.parse(localStorage.getItem("appid"))
					var timo = {
						appId:	params.appId,
						timeStamp:  params.timeStamp,
						nonceStr: params.nonceStr,
						package:  params.packageValue,
						signType: params.signType,
						paySign: params.paySign
					}
					let that = this
					WeixinJSBridge.invoke(
						'getBrandWCPayRequest',timo,
						function (res) {
							console.log(res);
							if (res.err_msg === 'get_brand_wcpay_request:ok') {
								Dialog.alert({
									title: '支付成功',
									theme: 'round-button',
									confirmButtonColor: "#bf985e"
								}).then(() => {
                  that.$router.push({ path: "/pay-result",query:{orderNumbers:that.orderNumbers,sts:1,payType:that.payType,orderType:that.orderType}});
								});
							} else if (res.err_msg === 'get_brand_wcpay_request:fail') {
                console.log('支付失败');
								Dialog.alert({
									title: '支付失败',
									theme: 'round-button',
									confirmButtonColor: "#bf985e"
								}).then(() => {
                  that.$router.push({ path: "/pay-result",query:{orderNumbers:that.orderNumbers,sts:0,payType:that.payType,orderType:that.orderType}});
									// on close
								});
							}
						}
					)
				},
    getWechatCode() {
				if (isWechat) {
					//this.calcTotalPrice() 
					let appid = "wx2fdbabccb9206fec"; //微信APPid
					let code = this.getUrlCode().code; //是否存在code
					let local = window.location.href;
					if (code == null || code === "") {
						//不存在就打开上面的地址进行授权
						window.location.href =
							"https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
							appid +
							"&redirect_uri=" +
							encodeURIComponent(local) +
							"&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect";
					} else {
						this.code = code;
						this.getopenid()
						console.log(this.code);
					}
				}
			},
      getUrlCode() {
				// 截取url中的code方法
				var url = location.search;
				var theRequest = new Object();
				if (url.indexOf("?") != -1) {
					var str = url.substr(1);
					var strs = str.split("&");
					for (var i = 0; i < strs.length; i++) {
						theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
					}
				}
				console.log(theRequest);
				//this.getWechatCode()
				return theRequest;
			},
			getopenid() {
				var that = this;
        getOpenids(that.code).then((res) => {
        console.log(res,'getopenids');
        //this.userInfo = res.data;
      });
			},
    //订单修改地址
    uPaddress(orderNumber,addrOrderId,status,payTime){
      console.log(orderNumber,addrOrderId,status,payTime,'orderNumber,addrOrderId,status,payTime');
      this.$router.push({ name: "delivery-address",params:{addrOrderId:addrOrderId} });
    },
    toDeliveryPage(orderNumber){
      console.log(orderNumber,'orderNumber');
      this.$router.push({ name: "logisticsInfo",params:{ orderNumber} });
    },
    toOrderDetailPage(orderNumber){
      console.log(orderNumber,'orderNumber');
      this.$router.push({  name: "order-detail",params:{ orderNumber} });
    },
    Myorder() {
      if(this.active == 4){
        let data = {
        status: 5,
        size: this.size,
        current: this.current,
      };
      GetmyOrder(data).then((res) => {
        console.log(res);
        res.data.records.forEach((orderItem) => {
          orderItem.totalCounts = 0;
          orderItem.totalUseScore = 0;
          orderItem.orderItemDtos.forEach((prod) => {
            orderItem.totalCounts += prod.prodCount;
            orderItem.totalUseScore += prod.useScore;
          });
        });
        var list = [];
        if (res.data.current == 1) {
          list = res.data.records;
        } else {
          list = this.data.list.concat(res.data.records);
        }
        console.log(list, "list");
        this.list = list;
        this.orders = list;
        this.pages = res.data.pages;
        this.current = res.data.current;
      });
      }else{
        let data = {
        status: this.active,
        size: this.size,
        current: this.current,
      };
      GetmyOrder(data).then((res) => {
        console.log(res);
        res.data.records.forEach((orderItem) => {
          orderItem.totalCounts = 0;
          orderItem.totalUseScore = 0;
          orderItem.orderItemDtos.forEach((prod) => {
            orderItem.totalCounts += prod.prodCount;
            orderItem.totalUseScore += prod.useScore;
          });
        });
        var list = [];
        if (res.data.current == 1) {
          list = res.data.records;
        } else {
          list = this.data.list.concat(res.data.records);
        }
        console.log(list, "list");
        this.list = list;
        this.orders = list;
        this.pages = res.data.pages;
        this.current = res.data.current;
      });
      }
      
      
    },
    onClickLeft() {
      //this.$router.go(-1);
      this.$router.push({ path: "/home" });
    },
    onClick(name, title) {
      console.log(name, title);
      this.active = name;
      this.Myorder();
    },
    orderinfo() {
      this.$router.push({ path: "/submit-order" });
    },
  },
};
</script>
<style lang="less" scoped>
.van-button{
  width: 100%;
}
.van-radio-group--horizontal{
  justify-content: center;
}
.van-radio_label{
  font-size: 14px !important;
}
.prod-item {
  background-color: #fff;
  font-size: 14px;
  margin: 15px;
  border-radius: 12px;
  .order-num {
    padding: 10px 15px;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    .order-state {
      display: flex;
      align-items: center;
      font-size: 12px;
      .reds {
        color: #d03636;
        font-size: 16px;
      }
    }
  }
  .item-cont {
    position: relative;
    display: flex;
    background: #fafafa;
    align-items: center;
    padding: 10px 15px;
    border-radius: 5px;
    .prod-pic {
      position: relative;
      font-size: 0;
      display: inline-block;
      width: 80px;
      height: 80px;
      overflow: hidden;
      background: #fff;
      margin-right: 8px;
      border: 1px solid #eeeeee;
      border-radius: 12px;
      image {
        width: 100%;
        height: 100%;
      }
    }
    .prod-info {
      margin-left: 5px;
      font-size: 14px;
      width: 100%;
      position: relative;
      height: 85px;
      -ms-flex: 1;
      -webkit-box-flex: 1;
      -moz-box-flex: 1;
      flex: 1;
      .prodname {
        font-size: 14px;
        line-height: 18px;
        max-height: 43px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        word-break: break-all;
      }
      .prod-info-cont {
        display: inline-block;
        vertical-align: middle;
        padding-bottom: 5px;
        line-height: 1em;
        .prod-skuname {
          color: #999;
          line-height: 20px;
          margin-top: 5px;
          font-size: 12px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;
          word-break: break-all;
        }
      }
      .prodprice {
        color: #333;
        position: absolute;
        bottom: 0;
        .symbol {
          font-size: 12px;
        }
        .big-num {
          font-size: 16px;
        }
        .small-num {
          font-size: 12px;
        }
      }
      .prodcount {
        position: absolute;
        bottom: 2px;
        right: 0;
        color: #999;
        font-family: verdana;
      }
    }
  }
  .total-num {
    text-align: right;
    padding: 10px 15px;
    font-size: 14px;
    .prodcount {
      margin-right: 10px;
      color: #747876;
      font-size: 14px;
      font-weight: 400;
    }
    .prodprice {
      display: inline-block;
      color: #0d1401;
      font-weight: bold;
      .symbol {
        font-size: 12px;
      }
      .big-num {
        font-size: 16px;
      }
      .small-num {
        font-size: 12px;
      }
    }
  }
  .prod-foot {
    padding: 10px 15px;
    border-top: 1px solid #e6e6e6;
    display: flex;
    flex-direction: row-reverse;
    .btn {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .button {
        margin-left: 10px;
        font-size: 14px;
        background: #fff;
        padding: 5px 15px;
        border-radius: 40px;
        border: 1px solid #747876;
      }
    }
  }
}
/* 列表为空 */
.empty {
  padding-top: 100px;
  text-align: cneter;
}
.empty-icon {
  display: block;
  width: 40px;
  height: 40px;
  margin: 0 auto;
  margin-bottom: 10px;
}
.empty-icon > img {
  display: block;
  width: 100%;
  height: 100%;
}
.empty-text {
  font-size: 14px;
  text-align: center;
  color: #999;
  line-height: 2em;
}
</style>
